 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"add-results":"add-results","admin~create-session~settings":"admin~create-session~settings","settings":"settings","auth":"auth","admin":"admin","create-session~crews-page":"create-session~crews-page","create-event~create-session":"create-event~create-session","create-session":"create-session","calendar~crews-page":"calendar~crews-page","calendar":"calendar","create-event":"create-event","event~squads":"event~squads","event":"event","add-member":"add-member","challenges":"challenges","challenges-public":"challenges-public","profile":"profile","reports":"reports","session":"session","reports-additional":"reports-additional","reports-drv":"reports-drv","club-members":"club-members","create-club":"create-club","crews-page":"crews-page","equipment":"equipment","squads":"squads","handle-stripe-payment":"handle-stripe-payment","home":"home","invitation":"invitation","notifications":"notifications","search-results":"search-results","settings-integrations":"settings-integrations","styleguide":"styleguide","unauthorized":"unauthorized","upgrade-to-performance":"upgrade-to-performance","welcome":"welcome","search":"search"}[chunkId]||chunkId) + "." + {"add-results":"be5da05c","admin~create-session~settings":"a76f125d","settings":"0952f405","auth":"a0a124e9","chunk-07bf01b8":"3f8b31c3","chunk-0ae98b3b":"9e29883c","chunk-2d0e455c":"4f328d00","chunk-2d217c19":"16f8030a","admin":"b0d7305f","create-session~crews-page":"24e5f31b","create-event~create-session":"930600c2","create-session":"762d1b70","chunk-20022468":"ccf960d6","chunk-3f54b6bc":"cb9b025e","calendar~crews-page":"33862231","calendar":"b26bf76d","create-event":"3eacb0b2","event~squads":"18d15966","event":"55fbd4b3","chunk-3cf11fa2":"68b3c76e","chunk-5a179f18":"1b7e259d","chunk-6cd8e0ab":"4ea80164","chunk-76dbe632":"7e628ccd","add-member":"f6a2d86c","chunk-73bdca1e":"eb195a8a","challenges":"a386ee10","challenges-public":"7dfaf7cf","profile":"39a3753d","reports":"6759b32f","session":"eb2a52d6","reports-additional":"280f80bf","reports-drv":"21a3fe70","club-members":"bfa4119b","chunk-78c46455":"9d915b74","chunk-cb5a981c":"c446a1aa","create-club":"b1ca44af","crews-page":"4b754d84","equipment":"2f8bd47a","squads":"c64a8246","handle-stripe-payment":"5fcbb6ca","home":"38c1ce8a","invitation":"ff8b7455","notifications":"55792528","search-results":"bf1d612c","settings-integrations":"b5adcf6b","styleguide":"4cce6ddc","unauthorized":"e50bebc7","upgrade-to-performance":"28e14edf","welcome":"ddfb817c","chunk-2d2084b8":"fc5d3f4a","chunk-2d2383f6":"369cee53","chunk-4cc349f6":"bcd1766c","chunk-5def997f":"d1b21610","chunk-2d0b71fc":"0577e0cf","chunk-7576b510":"1ab952ea","search":"6858af5a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"crews-page":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"add-results":"add-results","admin~create-session~settings":"admin~create-session~settings","settings":"settings","auth":"auth","admin":"admin","create-session~crews-page":"create-session~crews-page","create-event~create-session":"create-event~create-session","create-session":"create-session","calendar~crews-page":"calendar~crews-page","calendar":"calendar","create-event":"create-event","event~squads":"event~squads","event":"event","add-member":"add-member","challenges":"challenges","challenges-public":"challenges-public","profile":"profile","reports":"reports","session":"session","reports-additional":"reports-additional","reports-drv":"reports-drv","club-members":"club-members","create-club":"create-club","crews-page":"crews-page","equipment":"equipment","squads":"squads","handle-stripe-payment":"handle-stripe-payment","home":"home","invitation":"invitation","notifications":"notifications","search-results":"search-results","settings-integrations":"settings-integrations","styleguide":"styleguide","unauthorized":"unauthorized","upgrade-to-performance":"upgrade-to-performance","welcome":"welcome","search":"search"}[chunkId]||chunkId) + "." + {"add-results":"31d6cfe0","admin~create-session~settings":"31d6cfe0","settings":"31d6cfe0","auth":"31d6cfe0","chunk-07bf01b8":"31d6cfe0","chunk-0ae98b3b":"31d6cfe0","chunk-2d0e455c":"31d6cfe0","chunk-2d217c19":"31d6cfe0","admin":"31d6cfe0","create-session~crews-page":"31d6cfe0","create-event~create-session":"31d6cfe0","create-session":"31d6cfe0","chunk-20022468":"31d6cfe0","chunk-3f54b6bc":"31d6cfe0","calendar~crews-page":"31d6cfe0","calendar":"31d6cfe0","create-event":"31d6cfe0","event~squads":"31d6cfe0","event":"31d6cfe0","chunk-3cf11fa2":"31d6cfe0","chunk-5a179f18":"31d6cfe0","chunk-6cd8e0ab":"31d6cfe0","chunk-76dbe632":"31d6cfe0","add-member":"31d6cfe0","chunk-73bdca1e":"31d6cfe0","challenges":"31d6cfe0","challenges-public":"31d6cfe0","profile":"31d6cfe0","reports":"31d6cfe0","session":"31d6cfe0","reports-additional":"31d6cfe0","reports-drv":"31d6cfe0","club-members":"31d6cfe0","chunk-78c46455":"31d6cfe0","chunk-cb5a981c":"31d6cfe0","create-club":"31d6cfe0","crews-page":"bc1d3983","equipment":"31d6cfe0","squads":"31d6cfe0","handle-stripe-payment":"31d6cfe0","home":"31d6cfe0","invitation":"31d6cfe0","notifications":"31d6cfe0","search-results":"31d6cfe0","settings-integrations":"31d6cfe0","styleguide":"31d6cfe0","unauthorized":"31d6cfe0","upgrade-to-performance":"31d6cfe0","welcome":"31d6cfe0","chunk-2d2084b8":"31d6cfe0","chunk-2d2383f6":"31d6cfe0","chunk-4cc349f6":"31d6cfe0","chunk-5def997f":"31d6cfe0","chunk-2d0b71fc":"31d6cfe0","chunk-7576b510":"31d6cfe0","search":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
